import { useEffect } from 'react';
import PartidoAlineacionesProbablesMain from './PartidoAlineacionesProbablesMain';
import useFantasySelected from '@/DesignSystem/hooks/useFantasySelected';
import { RecomendacionesProvider, useRecomendaciones } from '@/context/RecomendacionesProvider';
import { PartidoAlineacionesProvider } from './PartidoAlineacionesContext';

const PartidoAlineacionesProbablesContent = ({ data }) => {
    const { season } = data?.fixture ?? {};
    const { fetchRecomendaciones } = useRecomendaciones();

    // Fetch recomendaciones (se mantiene aquí porque depende del RecomendacionesProvider)
    useEffect(() => {
        const round = data?.fixture?.round;
        const homeId = data?.home?.id;
        const awayId = data?.away?.id;

        if (data?.mode === 'predict' && round && (homeId > 0 || awayId > 0)) {
            const teamIds = [];
            if (homeId > 0) teamIds.push(homeId);
            if (awayId > 0) teamIds.push(awayId);
            fetchRecomendaciones(teamIds, round);
        }
    }, [data?.mode, data?.fixture?.round, data?.home?.id, data?.away?.id, season, fetchRecomendaciones]);

    return <PartidoAlineacionesProbablesMain />;
};

const PartidoAlineacionesProbablesWithContext = ({ data }) => {
    const { confirmedFantasy, confirmedFantasyMode } = useFantasySelected();

    const handleOpenJugador = () => {
        // Función placeholder - puede implementarse después si es necesario
    };

    return (
        <PartidoAlineacionesProvider
            data={data}
            handleOpenJugador={handleOpenJugador}
            confirmedFantasy={confirmedFantasy}
            confirmedFantasyMode={confirmedFantasyMode}
        >
            <PartidoAlineacionesProbablesContent data={data} />
        </PartidoAlineacionesProvider>
    );
};

const PartidoAlineacionesProbables = ({ data }) => {
    return (
        <RecomendacionesProvider>
            <PartidoAlineacionesProbablesWithContext data={data} />
        </RecomendacionesProvider>
    );
};

export default PartidoAlineacionesProbables;
